import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-surl-detail',
  templateUrl: './surl-detail.component.html'
})
export class SurlDetailComponent implements OnInit {
  surl:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/surl/surls/${id}`).subscribe(
            data => {
              this.setSurl(data)
            }
          );
        }
      });
  }

  setSurl(surl:any) {
    this.surl = surl;
  }

  createNew() {
    this.surl = {
    };
  }

  save() {
    if (!this.surl.id) {
      this.http.post(`${this.env.e.url}/surl/surls`, this.surl)
        .subscribe(
          data => {
            this.setSurl(data)
            this.alertService.info(`Created ${this.surl.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/surl/surls/${this.surl.id}`, this.surl)
        .subscribe(
          data => {
            this.setSurl(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/surl/surls/${this.surl.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.surl.name}`);
          this.router.navigate(["/surls"]);
        }
      );
  }
}
